import React from 'react'
import Box from '../../../core/components/box/Box'
import VisibleLeafSolutionContent from '../containers/VisibleLeafSolutionContent'
import './topicProblemSolutions.css'

const TopicProblemSolutions = ({solutions, addActiveSolution, activeSolutionIds, topicId, createSolution, toggleVote}) => {
  const activeSolutions = []
  for (let i = 0; i < activeSolutionIds.length; i++){
    activeSolutions.push(
      <Box marginBottom={4} key={i}>
        <VisibleLeafSolutionContent
          topicId={topicId}
          className='topic-problem-solutions__solution'
          as={`leafSolution${i}`} />
      </Box>
    )
  }

  if (solutions && solutions.length) {
    return (
      <div className="topic-problem-solutions">
        <div className="topic-problem-solutions__select-container">
          <h3 className="topic-problem__head">
            <b>Solutions</b> ({solutions.length})
          </h3>
        </div>
        {activeSolutions}
      </div>
    )
  } else {
    return null
  }
}

export default TopicProblemSolutions



// WEBPACK FOOTER //
// ./src/domains/topic/components/TopicProblemSolutions.js